"use strict";

var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _wrapNativeSuper = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var ne = Object.defineProperty;
var ge = Object.getOwnPropertyDescriptor;
var be = Object.getOwnPropertyNames;
var Te = Object.prototype.hasOwnProperty;
var Ae = function Ae(e, t) {
    for (var r in t) ne(e, r, {
      get: t[r],
      enumerable: !0
    });
  },
  Ie = function Ie(e, t, r, n) {
    if (t && typeof t == "object" || typeof t == "function") {
      var _iterator = _createForOfIteratorHelper(be(t)),
        _step;
      try {
        var _loop = function _loop() {
          var i = _step.value;
          !Te.call(e, i) && i !== r && ne(e, i, {
            get: function get() {
              return t[i];
            },
            enumerable: !(n = ge(t, i)) || n.enumerable
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return e;
  };
var De = function De(e) {
  return Ie(ne({}, "__esModule", {
    value: !0
  }), e);
};
var Be = {};
Ae(Be, {
  Immer: function Immer() {
    return J;
  },
  applyPatches: function applyPatches() {
    return Ce;
  },
  castDraft: function castDraft() {
    return ke;
  },
  castImmutable: function castImmutable() {
    return Ke;
  },
  createDraft: function createDraft() {
    return Re;
  },
  current: function current() {
    return re;
  },
  enableMapSet: function enableMapSet() {
    return xe;
  },
  enablePatches: function enablePatches() {
    return Pe;
  },
  finishDraft: function finishDraft() {
    return ve;
  },
  freeze: function freeze() {
    return K;
  },
  immerable: function immerable() {
    return N;
  },
  isDraft: function isDraft() {
    return O;
  },
  isDraftable: function isDraftable() {
    return A;
  },
  nothing: function nothing() {
    return j;
  },
  original: function original() {
    return le;
  },
  produce: function produce() {
    return Fe;
  },
  produceWithPatches: function produceWithPatches() {
    return Ne;
  },
  setAutoFreeze: function setAutoFreeze() {
    return ze;
  },
  setUseStrictShallowCopy: function setUseStrictShallowCopy() {
    return je;
  }
});
module.exports = De(Be);
var j = Symbol.for("immer-nothing"),
  N = Symbol.for("immer-draftable"),
  u = Symbol.for("immer-state");
function h(e) {
  throw new Error("[Immer] minified error nr: ".concat(e, ". Full error at: https://bit.ly/3cXEKWf"));
}
var z = Object.getPrototypeOf;
function O(e) {
  return !!e && !!e[u];
}
function A(e) {
  return e ? ye(e) || Array.isArray(e) || !!e[N] || !!e.constructor?.[N] || v(e) || k(e) : !1;
}
var Oe = Object.prototype.constructor.toString();
function ye(e) {
  if (!e || typeof e != "object") return !1;
  var t = z(e);
  if (t === null) return !0;
  var r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return r === Object ? !0 : typeof r == "function" && Function.toString.call(r) === Oe;
}
function le(e) {
  return O(e) || h(15, e), e[u].t;
}
function _(e, t) {
  C(e) === 0 ? Reflect.ownKeys(e).forEach(function (r) {
    t(r, e[r], e);
  }) : e.forEach(function (r, n) {
    return t(n, r, e);
  });
}
function C(e) {
  var t = e[u];
  return t ? t.o : Array.isArray(e) ? 1 : v(e) ? 2 : k(e) ? 3 : 0;
}
function R(e, t) {
  return C(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function X(e, t) {
  return C(e) === 2 ? e.get(t) : e[t];
}
function Q(e, t, r) {
  var n = C(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function pe(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function v(e) {
  return e instanceof Map;
}
function k(e) {
  return e instanceof Set;
}
function T(e) {
  return e.e || e.t;
}
function L(e, t) {
  if (v(e)) return new Map(e);
  if (k(e)) return new Set(e);
  if (Array.isArray(e)) return Array.prototype.slice.call(e);
  var r = ye(e);
  if (t === !0 || t === "class_only" && !r) {
    var n = Object.getOwnPropertyDescriptors(e);
    delete n[u];
    var i = Reflect.ownKeys(n);
    for (var f = 0; f < i.length; f++) {
      var l = i[f],
        c = n[l];
      c.writable === !1 && (c.writable = !0, c.configurable = !0), (c.get || c.set) && (n[l] = {
        configurable: !0,
        writable: !0,
        enumerable: c.enumerable,
        value: e[l]
      });
    }
    return Object.create(z(e), n);
  } else {
    var _n = z(e);
    if (_n !== null && r) return _objectSpread({}, e);
    var _i = Object.create(_n);
    return Object.assign(_i, e);
  }
}
function K(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  return $(e) || O(e) || !A(e) || (C(e) > 1 && (e.set = e.add = e.clear = e.delete = Me), Object.freeze(e), t && Object.entries(e).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      r = _ref2[0],
      n = _ref2[1];
    return K(n, !0);
  })), e;
}
function Me() {
  h(2);
}
function $(e) {
  return Object.isFrozen(e);
}
var ae = {};
function w(e) {
  var t = ae[e];
  return t || h(0, e), t;
}
function Y(e, t) {
  ae[e] || (ae[e] = t);
}
var U;
function B() {
  return U;
}
function _e(e, t) {
  return {
    a: [],
    i: e,
    p: t,
    P: !0,
    d: 0
  };
}
function oe(e, t) {
  t && (w("Patches"), e.f = [], e.h = [], e.b = t);
}
function V(e) {
  Z(e), e.a.forEach(we), e.a = null;
}
function Z(e) {
  e === U && (U = e.i);
}
function ie(e) {
  return U = _e(U, e);
}
function we(e) {
  var t = e[u];
  t.o === 0 || t.o === 1 ? t.x() : t.m = !0;
}
function se(e, t) {
  t.d = t.a.length;
  var r = t.a[0];
  return e !== void 0 && e !== r ? (r[u].s && (V(t), h(4)), A(e) && (e = ee(t, e), t.i || te(t, e)), t.f && w("Patches").T(r[u].t, e, t.f, t.h)) : e = ee(t, r, []), V(t), t.f && t.b(t.f, t.h), e !== j ? e : void 0;
}
function ee(e, t, r) {
  if ($(t)) return t;
  var n = t[u];
  if (!n) return _(t, function (i, f) {
    return de(e, n, t, i, f, r);
  }), t;
  if (n.n !== e) return t;
  if (!n.s) return te(e, n.t, !0), n.t;
  if (!n.c) {
    n.c = !0, n.n.d--;
    var i = n.e,
      f = i,
      l = !1;
    n.o === 3 && (f = new Set(i), i.clear(), l = !0), _(f, function (c, b) {
      return de(e, n, i, c, b, r, l);
    }), te(e, i, !1), r && e.f && w("Patches").g(n, r, e.f, e.h);
  }
  return n.e;
}
function de(e, t, r, n, i, f, l) {
  if (O(i)) {
    var c = f && t && t.o !== 3 && !R(t.r, n) ? f.concat(n) : void 0,
      b = ee(e, i, c);
    if (Q(r, n, b), O(b)) e.P = !1;else return;
  } else l && r.add(i);
  if (A(i) && !$(i)) {
    if (!e.p.y && e.d < 1) return;
    ee(e, i), (!t || !t.n.i) && typeof n != "symbol" && Object.prototype.propertyIsEnumerable.call(r, n) && te(e, i);
  }
}
function te(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  !e.i && e.p.y && e.P && K(t, r);
}
function he(e, t) {
  var r = Array.isArray(e),
    n = {
      o: r ? 1 : 0,
      n: t ? t.n : B(),
      s: !1,
      c: !1,
      r: {},
      i: t,
      t: e,
      u: null,
      e: null,
      x: null,
      l: !1
    },
    i = n,
    f = ue;
  r && (i = [n], f = q);
  var _Proxy$revocable = Proxy.revocable(i, f),
    l = _Proxy$revocable.revoke,
    c = _Proxy$revocable.proxy;
  return n.u = c, n.x = l, c;
}
var ue = {
    get: function get(e, t) {
      if (t === u) return e;
      var r = T(e);
      if (!R(r, t)) return Ee(e, r, t);
      var n = r[t];
      return e.c || !A(n) ? n : n === ce(e.t, t) ? (fe(e), e.e[t] = W(n, e)) : n;
    },
    has: function has(e, t) {
      return t in T(e);
    },
    ownKeys: function ownKeys(e) {
      return Reflect.ownKeys(T(e));
    },
    set: function set(e, t, r) {
      var n = me(T(e), t);
      if (n?.set) return n.set.call(e.u, r), !0;
      if (!e.s) {
        var i = ce(T(e), t),
          f = i?.[u];
        if (f && f.t === r) return e.e[t] = r, e.r[t] = !1, !0;
        if (pe(r, i) && (r !== void 0 || R(e.t, t))) return !0;
        fe(e), E(e);
      }
      return e.e[t] === r && (r !== void 0 || t in e.e) || Number.isNaN(r) && Number.isNaN(e.e[t]) || (e.e[t] = r, e.r[t] = !0), !0;
    },
    deleteProperty: function deleteProperty(e, t) {
      return ce(e.t, t) !== void 0 || t in e.t ? (e.r[t] = !1, fe(e), E(e)) : delete e.r[t], e.e && delete e.e[t], !0;
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
      var r = T(e),
        n = Reflect.getOwnPropertyDescriptor(r, t);
      return n && {
        writable: !0,
        configurable: e.o !== 1 || t !== "length",
        enumerable: n.enumerable,
        value: r[t]
      };
    },
    defineProperty: function defineProperty() {
      h(11);
    },
    getPrototypeOf: function getPrototypeOf(e) {
      return z(e.t);
    },
    setPrototypeOf: function setPrototypeOf() {
      h(12);
    }
  },
  q = {};
_(ue, function (e, t) {
  q[e] = function () {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
q.deleteProperty = function (e, t) {
  return q.set.call(this, e, t, void 0);
};
q.set = function (e, t, r) {
  return ue.set.call(this, e[0], t, r, e[0]);
};
function ce(e, t) {
  var r = e[u];
  return (r ? T(r) : e)[t];
}
function Ee(e, t, r) {
  var n = me(t, r);
  return n ? "value" in n ? n.value : n.get?.call(e.u) : void 0;
}
function me(e, t) {
  if (!(t in e)) return;
  var r = z(e);
  for (; r;) {
    var n = Object.getOwnPropertyDescriptor(r, t);
    if (n) return n;
    r = z(r);
  }
}
function E(e) {
  e.s || (e.s = !0, e.i && E(e.i));
}
function fe(e) {
  e.e || (e.e = L(e.t, e.n.p.S));
}
var J = /*#__PURE__*/function () {
  function J(t) {
    var _this = this;
    _classCallCheck(this, J);
    this.y = !0;
    this.S = !1;
    this.produce = function (t, r, n) {
      if (typeof t == "function" && typeof r != "function") {
        var f = r;
        r = t;
        var l = _this;
        return function () {
          var _this2 = this;
          var b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : f;
          for (var _len = arguments.length, a = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            a[_key - 1] = arguments[_key];
          }
          return l.produce(b, function (o) {
            var _r;
            return (_r = r).call.apply(_r, [_this2, o].concat(a));
          });
        };
      }
      typeof r != "function" && h(6), n !== void 0 && typeof n != "function" && h(7);
      var i;
      if (A(t)) {
        var _f = ie(_this),
          _l = W(t, void 0),
          c = !0;
        try {
          i = r(_l), c = !1;
        } finally {
          c ? V(_f) : Z(_f);
        }
        return oe(_f, n), se(i, _f);
      } else if (!t || typeof t != "object") {
        if (i = r(t), i === void 0 && (i = t), i === j && (i = void 0), _this.y && K(i, !0), n) {
          var _f2 = [],
            _l2 = [];
          w("Patches").T(t, i, _f2, _l2), n(_f2, _l2);
        }
        return i;
      } else h(1, t);
    };
    this.produceWithPatches = function (t, r) {
      if (typeof t == "function") return function (l) {
        for (var _len2 = arguments.length, c = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          c[_key2 - 1] = arguments[_key2];
        }
        return _this.produceWithPatches(l, function (b) {
          return t.apply(void 0, [b].concat(c));
        });
      };
      var n, i;
      return [_this.produce(t, r, function (l, c) {
        n = l, i = c;
      }), n, i];
    };
    typeof t?.autoFreeze == "boolean" && this.setAutoFreeze(t.autoFreeze), typeof t?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(t.useStrictShallowCopy);
  }
  _createClass(J, [{
    key: "createDraft",
    value: function createDraft(t) {
      A(t) || h(8), O(t) && (t = re(t));
      var r = ie(this),
        n = W(t, void 0);
      return n[u].l = !0, Z(r), n;
    }
  }, {
    key: "finishDraft",
    value: function finishDraft(t, r) {
      var n = t && t[u];
      (!n || !n.l) && h(9);
      var i = n.n;
      return oe(i, r), se(void 0, i);
    }
  }, {
    key: "setAutoFreeze",
    value: function setAutoFreeze(t) {
      this.y = t;
    }
  }, {
    key: "setUseStrictShallowCopy",
    value: function setUseStrictShallowCopy(t) {
      this.S = t;
    }
  }, {
    key: "applyPatches",
    value: function applyPatches(t, r) {
      var n;
      for (n = r.length - 1; n >= 0; n--) {
        var f = r[n];
        if (f.path.length === 0 && f.op === "replace") {
          t = f.value;
          break;
        }
      }
      n > -1 && (r = r.slice(n + 1));
      var i = w("Patches").A;
      return O(t) ? i(t, r) : this.produce(t, function (f) {
        return i(f, r);
      });
    }
  }]);
  return J;
}();
function W(e, t) {
  var r = v(e) ? w("MapSet").I(e, t) : k(e) ? w("MapSet").D(e, t) : he(e, t);
  return (t ? t.n : B()).a.push(r), r;
}
function re(e) {
  return O(e) || h(10, e), Se(e);
}
function Se(e) {
  if (!A(e) || $(e)) return e;
  var t = e[u],
    r;
  if (t) {
    if (!t.s) return t.t;
    t.c = !0, r = L(e, t.n.p.S);
  } else r = L(e, !0);
  return _(r, function (n, i) {
    Q(r, n, Se(i));
  }), t && (t.c = !1), r;
}
function Pe() {
  var t = "replace",
    r = "add",
    n = "remove";
  function i(s, S, m, x) {
    switch (s.o) {
      case 0:
      case 2:
        return l(s, S, m, x);
      case 1:
        return f(s, S, m, x);
      case 3:
        return c(s, S, m, x);
    }
  }
  function f(s, S, m, x) {
    var _ref3, _ref4;
    var I = s.t,
      P = s.r,
      g = s.e;
    g.length < I.length && (_ref3 = [g, I], I = _ref3[0], g = _ref3[1], _ref3, _ref4 = [x, m], m = _ref4[0], x = _ref4[1], _ref4);
    for (var y = 0; y < I.length; y++) if (P[y] && g[y] !== I[y]) {
      var d = S.concat([y]);
      m.push({
        op: t,
        path: d,
        value: p(g[y])
      }), x.push({
        op: t,
        path: d,
        value: p(I[y])
      });
    }
    for (var _y = I.length; _y < g.length; _y++) {
      var _d = S.concat([_y]);
      m.push({
        op: r,
        path: _d,
        value: p(g[_y])
      });
    }
    for (var _y2 = g.length - 1; I.length <= _y2; --_y2) {
      var _d2 = S.concat([_y2]);
      x.push({
        op: n,
        path: _d2
      });
    }
  }
  function l(s, S, m, x) {
    var I = s.t,
      P = s.e;
    _(s.r, function (g, y) {
      var d = X(I, g),
        H = X(P, g),
        F = y ? R(I, g) ? t : r : n;
      if (d === H && F === t) return;
      var D = S.concat(g);
      m.push(F === n ? {
        op: F,
        path: D
      } : {
        op: F,
        path: D,
        value: H
      }), x.push(F === r ? {
        op: n,
        path: D
      } : F === n ? {
        op: r,
        path: D,
        value: p(d)
      } : {
        op: t,
        path: D,
        value: p(d)
      });
    });
  }
  function c(s, S, m, x) {
    var I = s.t,
      P = s.e,
      g = 0;
    I.forEach(function (y) {
      if (!P.has(y)) {
        var d = S.concat([g]);
        m.push({
          op: n,
          path: d,
          value: y
        }), x.unshift({
          op: r,
          path: d,
          value: y
        });
      }
      g++;
    }), g = 0, P.forEach(function (y) {
      if (!I.has(y)) {
        var d = S.concat([g]);
        m.push({
          op: r,
          path: d,
          value: y
        }), x.unshift({
          op: n,
          path: d,
          value: y
        });
      }
      g++;
    });
  }
  function b(s, S, m, x) {
    m.push({
      op: t,
      path: [],
      value: S === j ? void 0 : S
    }), x.push({
      op: t,
      path: [],
      value: s
    });
  }
  function a(s, S) {
    return S.forEach(function (m) {
      var x = m.path,
        I = m.op,
        P = s;
      for (var H = 0; H < x.length - 1; H++) {
        var F = C(P),
          D = x[H];
        typeof D != "string" && typeof D != "number" && (D = "" + D), (F === 0 || F === 1) && (D === "__proto__" || D === "constructor") && h(16 + 3), typeof P == "function" && D === "prototype" && h(16 + 3), P = X(P, D), typeof P != "object" && h(16 + 2, x.join("/"));
      }
      var g = C(P),
        y = o(m.value),
        d = x[x.length - 1];
      switch (I) {
        case t:
          switch (g) {
            case 2:
              return P.set(d, y);
            case 3:
              h(16);
            default:
              return P[d] = y;
          }
        case r:
          switch (g) {
            case 1:
              return d === "-" ? P.push(y) : P.splice(d, 0, y);
            case 2:
              return P.set(d, y);
            case 3:
              return P.add(y);
            default:
              return P[d] = y;
          }
        case n:
          switch (g) {
            case 1:
              return P.splice(d, 1);
            case 2:
              return P.delete(d);
            case 3:
              return P.delete(m.value);
            default:
              return delete P[d];
          }
        default:
          h(16 + 1, I);
      }
    }), s;
  }
  function o(s) {
    if (!A(s)) return s;
    if (Array.isArray(s)) return s.map(o);
    if (v(s)) return new Map(Array.from(s.entries()).map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        m = _ref6[0],
        x = _ref6[1];
      return [m, o(x)];
    }));
    if (k(s)) return new Set(Array.from(s).map(o));
    var S = Object.create(z(s));
    for (var m in s) S[m] = o(s[m]);
    return R(s, N) && (S[N] = s[N]), S;
  }
  function p(s) {
    return O(s) ? o(s) : s;
  }
  Y("Patches", {
    A: a,
    g: i,
    T: b
  });
}
function xe() {
  var e = /*#__PURE__*/function (_Map) {
    _inherits(e, _Map);
    function e(a, o) {
      var _this3;
      _classCallCheck(this, e);
      _this3 = _possibleConstructorReturn(this, _getPrototypeOf(e).call(this));
      _this3[u] = {
        o: 2,
        i: o,
        n: o ? o.n : B(),
        s: !1,
        c: !1,
        e: void 0,
        r: void 0,
        t: a,
        u: _assertThisInitialized(_assertThisInitialized(_this3)),
        l: !1,
        m: !1
      };
      return _this3;
    }
    _createClass(e, [{
      key: "has",
      value: function has(a) {
        return T(this[u]).has(a);
      }
    }, {
      key: "set",
      value: function set(a, o) {
        var p = this[u];
        return l(p), (!T(p).has(a) || T(p).get(a) !== o) && (r(p), E(p), p.r.set(a, !0), p.e.set(a, o), p.r.set(a, !0)), this;
      }
    }, {
      key: "delete",
      value: function _delete(a) {
        if (!this.has(a)) return !1;
        var o = this[u];
        return l(o), r(o), E(o), o.t.has(a) ? o.r.set(a, !1) : o.r.delete(a), o.e.delete(a), !0;
      }
    }, {
      key: "clear",
      value: function clear() {
        var a = this[u];
        l(a), T(a).size && (r(a), E(a), a.r = new Map(), _(a.t, function (o) {
          a.r.set(o, !1);
        }), a.e.clear());
      }
    }, {
      key: "forEach",
      value: function forEach(a, o) {
        var _this4 = this;
        var p = this[u];
        T(p).forEach(function (s, S, m) {
          a.call(o, _this4.get(S), S, _this4);
        });
      }
    }, {
      key: "get",
      value: function get(a) {
        var o = this[u];
        l(o);
        var p = T(o).get(a);
        if (o.c || !A(p) || p !== o.t.get(a)) return p;
        var s = W(p, o);
        return r(o), o.e.set(a, s), s;
      }
    }, {
      key: "keys",
      value: function keys() {
        return T(this[u]).keys();
      }
    }, {
      key: "values",
      value: function values() {
        var _this5 = this;
        var a = this.keys();
        return _defineProperty(_defineProperty({}, Symbol.iterator, function () {
          return _this5.values();
        }), "next", function next() {
          var o = a.next();
          return o.done ? o : {
            done: !1,
            value: _this5.get(o.value)
          };
        });
      }
    }, {
      key: "entries",
      value: function entries() {
        var _this6 = this;
        var a = this.keys();
        return _defineProperty(_defineProperty({}, Symbol.iterator, function () {
          return _this6.entries();
        }), "next", function next() {
          var o = a.next();
          if (o.done) return o;
          var p = _this6.get(o.value);
          return {
            done: !1,
            value: [o.value, p]
          };
        });
      }
    }, {
      key: (u, Symbol.iterator),
      value: function value() {
        return this.entries();
      }
    }, {
      key: "size",
      get: function get() {
        return T(this[u]).size;
      }
    }]);
    return e;
  }(_wrapNativeSuper(Map));
  function t(c, b) {
    return new e(c, b);
  }
  function r(c) {
    c.e || (c.r = new Map(), c.e = new Map(c.t));
  }
  var n = /*#__PURE__*/function (_Set) {
    _inherits(n, _Set);
    function n(a, o) {
      var _this7;
      _classCallCheck(this, n);
      _this7 = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this));
      _this7[u] = {
        o: 3,
        i: o,
        n: o ? o.n : B(),
        s: !1,
        c: !1,
        e: void 0,
        t: a,
        u: _assertThisInitialized(_assertThisInitialized(_this7)),
        a: new Map(),
        m: !1,
        l: !1
      };
      return _this7;
    }
    _createClass(n, [{
      key: "has",
      value: function has(a) {
        var o = this[u];
        return l(o), o.e ? !!(o.e.has(a) || o.a.has(a) && o.e.has(o.a.get(a))) : o.t.has(a);
      }
    }, {
      key: "add",
      value: function add(a) {
        var o = this[u];
        return l(o), this.has(a) || (f(o), E(o), o.e.add(a)), this;
      }
    }, {
      key: "delete",
      value: function _delete(a) {
        if (!this.has(a)) return !1;
        var o = this[u];
        return l(o), f(o), E(o), o.e.delete(a) || (o.a.has(a) ? o.e.delete(o.a.get(a)) : !1);
      }
    }, {
      key: "clear",
      value: function clear() {
        var a = this[u];
        l(a), T(a).size && (f(a), E(a), a.e.clear());
      }
    }, {
      key: "values",
      value: function values() {
        var a = this[u];
        return l(a), f(a), a.e.values();
      }
    }, {
      key: "entries",
      value: function entries() {
        var a = this[u];
        return l(a), f(a), a.e.entries();
      }
    }, {
      key: "keys",
      value: function keys() {
        return this.values();
      }
    }, {
      key: (u, Symbol.iterator),
      value: function value() {
        return this.values();
      }
    }, {
      key: "forEach",
      value: function forEach(a, o) {
        var p = this.values(),
          s = p.next();
        for (; !s.done;) a.call(o, s.value, s.value, this), s = p.next();
      }
    }, {
      key: "size",
      get: function get() {
        return T(this[u]).size;
      }
    }]);
    return n;
  }(_wrapNativeSuper(Set));
  function i(c, b) {
    return new n(c, b);
  }
  function f(c) {
    c.e || (c.e = new Set(), c.t.forEach(function (b) {
      if (A(b)) {
        var a = W(b, c);
        c.a.set(b, a), c.e.add(a);
      } else c.e.add(b);
    }));
  }
  function l(c) {
    c.m && h(3, JSON.stringify(T(c)));
  }
  Y("MapSet", {
    I: t,
    D: i
  });
}
var M = new J(),
  Fe = M.produce,
  Ne = M.produceWithPatches.bind(M),
  ze = M.setAutoFreeze.bind(M),
  je = M.setUseStrictShallowCopy.bind(M),
  Ce = M.applyPatches.bind(M),
  Re = M.createDraft.bind(M),
  ve = M.finishDraft.bind(M);
function ke(e) {
  return e;
}
function Ke(e) {
  return e;
}
0 && (module.exports = {
  Immer: Immer,
  applyPatches: applyPatches,
  castDraft: castDraft,
  castImmutable: castImmutable,
  createDraft: createDraft,
  current: current,
  enableMapSet: enableMapSet,
  enablePatches: enablePatches,
  finishDraft: finishDraft,
  freeze: freeze,
  immerable: immerable,
  isDraft: isDraft,
  isDraftable: isDraftable,
  nothing: nothing,
  original: original,
  produce: produce,
  produceWithPatches: produceWithPatches,
  setAutoFreeze: setAutoFreeze,
  setUseStrictShallowCopy: setUseStrictShallowCopy
});